import React from 'react';

export const TicketIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <defs>
      <path
        id="ticket-icon-a"
        d="M16 1.334C15.998.598 15.4 0 14.665 0H8.848c-.733 0-1.756.425-2.276.943L.389 7.126c-.519.518-.519 1.367 0 1.885l6.6 6.6c.517.519 1.367.52 1.885 0l.002.002 6.181-6.185c.52-.519.943-1.542.943-2.276V1.334zm-2.41 2.493c-.391.39-1.025.39-1.415 0-.39-.39-.39-1.024 0-1.415.39-.39 1.023-.39 1.414 0 .39.39.39 1.024 0 1.415z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="ticket-icon-b" fill="#fff">
        <use xlinkHref="#ticket-icon-a" />
      </mask>
      <use fill="#171C34" fillRule="nonzero" xlinkHref="#ticket-icon-a" />
      <g fill="#003D73" fillRule="nonzero" mask="url(#ticket-icon-b)">
        <path d="M0 0H16V16H0z" />
      </g>
    </g>
  </svg>
);
